import type {ComponentProps} from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';

import {FileAttachment} from './file-attachment';
import styles from './audio-attachment.module.css';

type Props = Omit<ComponentProps<typeof FileAttachment>, 'label'>;

export const AudioAttachment = ({className, ...props}: Props) => {
    const {formatMessage} = useIntl();
    const label = formatMessage({id: 'file_attachment.open_audio', defaultMessage: 'Open audio'});

    return <FileAttachment {...props} className={classNames(styles.root, className)} label={label} />;
};
